import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

class Icon extends React.Component {
  static get displayName() {
    return "Icon";
  }

  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      className: PropTypes.string,
      size: PropTypes.oneOf(["large", "2x", "3x", "4x", "5x"]),
      status: PropTypes.oneOf(["success", "danger", "muted"]),
      align: PropTypes.oneOf(["center"]),
    };
  }

  render() {
    let classes = ["icon"];

    if (this.props.className) {
      classes.push(this.props.className);
    }

    classes.push(`fa fa-${this.props.name}`);

    if (this.props.status) {
      classes.push(`text-${this.props.status}`);
    }

    if (this.props.align === "center") {
      classes.push("fa-fw");
    }

    switch (this.props.size) {
      case "large":
        classes.push("fa-lg");
        break;
      case "2x":
        classes.push("fa-2x");
        break;
      case "3x":
        classes.push("fa-3x");
        break;
      case "4x":
        classes.push("fa-4x");
        break;
      case "5x":
        classes.push("fa-5x");
        break;
      default:
        break;
    }

    return <i className={classNames(classes)}></i>;
  }
}

module.exports = Icon;
